import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';

import {InvoicesTable} from './components';

import {
  MODALS,
  fetchVoidableInvoicesForBookingSet,
  selectVoidableInvoicesForBookingSet,
  selectVoidableInvoicesForBookingSetIsLoading
} from 'ducks/bookingSets';
import {voidInvoices} from 'ducks/payments';

import {
  storeDataInModal,
  MODALS as BASE_MODALS,
  openModal,
  closeModal
} from 'ducks/modals';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

class BulkInvoiceVoidModal extends React.Component<any> {
  componentDidMount() {
    const {bookingSetId, locationRef} = this.props.data;

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.VOID_SCHEDULE_ITEMS
      },
      () =>
        this.props.fetchVoidableInvoicesForBookingSet({
          bookingSetId
        })
    );
  }

  voidInvoices = ({invoicesIds}) => {
    const {locationRef} = this.props.data;

    const confirmAction = () => {
      this.props.storeDataInModal({
        modalName: MODALS.BULK_INVOICE_VOID,
        data: {voidingInvoices: true}
      });
      this.props.voidInvoices(
        {
          invoices: invoicesIds
        },
        [
          ...this.props.closeModalExtraActions,
          ...this.props.storeDataExtraActions(() => ({
            voidingInvoices: false
          })),
          ...this.props.refetchExtraActions(),
          () => closeModal(BASE_MODALS.CONFIRM)
        ]
      );
    };

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.VOID_SCHEDULE_ITEMS
      },
      () => {
        this.props.openModal(BASE_MODALS.CONFIRM, {
          heading: 'Void invoices',
          question: 'Are you sure you want to void these invoices?',
          confirmAction
        });
      }
    );
  };

  render() {
    const {
      voidableInvoicesLoading,
      voidableInvoices,
      voidingInvoices
    } = this.props.data;
    const {redirectToBookingDetail, openInvoiceDetailModal} = this.props;

    return (
      <Modal
        className="BulkInvoiceVoidModal"
        show={true}
        type={Modal.MEDIUM}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Void invoices" />
        <Modal.Body>
          <p className="BulkInvoiceVoidModal__message">
            Chose voidable invoices:
          </p>
          <InvoicesTable
            invoices={voidableInvoices}
            isLoading={voidableInvoicesLoading}
            redirectToBookingDetail={redirectToBookingDetail}
            openInvoiceDetailModal={openInvoiceDetailModal}
            closeModal={this.props.closeModal}
            voidInvoices={this.voidInvoices}
            voidingInvoices={voidingInvoices}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToModalData = state => ({
  voidableInvoices: selectVoidableInvoicesForBookingSet(state),
  voidableInvoicesLoading: selectVoidableInvoicesForBookingSetIsLoading(state)
});

const mapDispatchToProps = {
  requiresPermission,
  fetchVoidableInvoicesForBookingSet,
  voidInvoices,
  storeDataInModal,
  openModal
};

export default withModal(
  MODALS.BULK_INVOICE_VOID,
  mapStateToModalData,
  mapDispatchToProps
)(BulkInvoiceVoidModal);
